<div
    class="flex flex-col items-stretch gap-5"
    *ngIf="{
        required: service.requiredColumnLabels(),
        optional: service.optionalColumnLabels(),
        explanationItems: service.explanationItems()
    } as viewModel"
>
    <div class="flex flex-col gap-2">
        <span class="font-bold" i18n>Upload Excel file</span>
        <span class="text-sm" i18n>Select an Excel file from your computer or drag the file to the box below:</span>
    </div>
    <div class="w-full p-3 rounded-2xl border-2 border-iota-outline flex flex-row gap-3 items-start">
        <iota-icon icon="information-circle" size="1.5" variation="solid"></iota-icon>
        <div class="flex flex-col">
            <div>
                <span i18n="@@yourFileMustContainTheColumnsPrefix">Your file must contain the columns </span>
                <span *ngFor="let label of viewModel.required; first as isFirst; last as isLast">
                    <span *ngIf="!isFirst && !isLast">, </span>
                    <span *ngIf="!isFirst && isLast" i18n> and </span>
                    <span class="font-bold">{{ label }}</span>
                </span>
                <span i18n="@@yourFileMustContainTheColumnsSuffix">.</span>
            </div>
            <ng-container *ngIf="viewModel.optional?.length > 0">
                <div>
                    <span i18n="@@yourFileMayContainOptionalColumnsPrefix">Optional you can add the following columns: </span>
                    <span *ngFor="let label of viewModel.optional; first as isFirst; last as isLast">
                        <span *ngIf="!isFirst && !isLast">, </span>
                        <span *ngIf="!isFirst && isLast" i18n> and </span>
                        <span class="font-bold">{{ label }}</span>
                        <span *ngIf="isLast && !label?.endsWith('.')">.</span>
                    </span>
                </div>
            </ng-container>
        </div>
        <div class="flex-1"></div>
        <button
            class="font-bold pb-1 border-b-2 border-black whitespace-nowrap"
            (click)="downloadTemplateFile(viewModel.required, viewModel.optional)"
        >
            <span i18n>Download template</span>
        </button>
    </div>
    <div class="grid grid-cols-2 gap-5">
        <div class="w-full p-3 rounded-2xl border-2 border-iota-outline flex flex-col gap-5" *ngIf="viewModel.explanationItems?.length > 0">
            <div class="flex flex-row gap-3 items-center">
                <iota-icon icon="information-circle" size="1.5" variation="solid"></iota-icon>
                <span i18n>In the file, these values must be correctly assigned per employee:</span>
            </div>
            <div class="w-full max-h-60 overflow-y-auto flex flex-col gap-1">
                <div class="w-full pr-5 flex flex-row items-start gap-1" *ngFor="let item of viewModel.explanationItems">
                    <span class="font-bold shrink-0">{{ item.label }}: </span>
                    <span>{{ item.description }}</span>
                </div>
            </div>
        </div>
        <div class="bg-iota-bg-dark rounded-2xl" [ngClass]="{ 'col-span-2': viewModel.explanationItems?.length === 0 }">
            <app-document-upload
                buttonText="Select the Excel file"
                i18n-buttonText
                [multi]="false"
                (filesSelected)="fileChanged($event)"
            ></app-document-upload>
        </div>
    </div>

    <div *ngIf="service.fileError() as fileError" class="alert alert-error">
        <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
        <span>{{ fileError }}</span>
    </div>
</div>
